import { urls } from "../../common/constant";
import { updateLoadingScreen } from '../Actions';
import http from "../../assets/extra/_httpServices";


export const getCities = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .GetRequestCached(urls.getCities, data, isCache, cacheDuration)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const getSearchRoutesBookBusTickets = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .GetRequestCached(urls.getSearchRoutesBookBusTickets, data, isCache, cacheDuration)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getChartBBT = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getChartBBT, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const getRouteDetails = (data, isCache = false, cacheDuration = 0, isdelete = false) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .GetRequestCached(urls.getRouteDetails, data, isCache, cacheDuration, isdelete)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};


export const getCancellationPoliciesV3 = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getCancellationPoliciesV3, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};


export const getCompanyAgentsRightsListAll = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .GetRequestCached(urls.getCompanyAgentsRightsListAll, data, isCache, cacheDuration)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};



export const getBBTPaymentConfig = (data, isCache = false, cacheDuration = 0) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .GetRequestCached(urls.getBBTPaymentConfig, data, isCache, cacheDuration)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const updateBookingsInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpCall(urls.updateBookingsInsertUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const getBookingsLoad = (data, isScreenLoader = false) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getBookingsLoad, data)
            .then((res) => {
                dispatch(updateLoadingScreen(isScreenLoader));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const updateBookingsModify = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpCall(urls.updateBookingsModify, "post", data, {})
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

//get /api/BBTCancelTicket/BookingsCancelV2


export const getBookingsCancelV2 = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getBookingsCancelV2, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};


export const checkBeneficiaryStatus = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.checkBeneficiaryStatus, data)
            .then((res) => {
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const generateQROrders = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpCallForQR(urls.generateQROrders, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};


export const bookingQrBkgDetailsInsertUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        http
            .HttpCall(urls.bookingQrBkgDetailsInsertUpdate, "post", data, {})
            .then((res) => {
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const getConsumed = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(false));
        http
            .HttpGetForQR(`/v1/orders/${data?.qrOrderId}/consumed?ConsumptionId=${data?.Bookingid},`, {})
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const bookingPaymentUnutilized = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.bookingPaymentUnutilized, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getConsumedList = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpCallForQR(urls.getConsumedList, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const generateQRRefund = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpCallForQR(urls.generateQRRefund, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};


export const getBBTLoginCompany = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getBBTLoginCompany, data)
            .then((res) => {
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};



export const getAgentUsersChangePassword = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpCall(urls.getAgentUsersChangePassword, "post", data, {})
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};


export const getGSTValidation = (url, data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .gstPanValidation(url, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};




export const getAgentBalance = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getAgentBalance, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};


export const getGPSCacheStatus = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getGPSCacheStatus, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const getBBTViaListCities = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getBBTViaListCities, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const checkSumForWebLogin = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.checkSumForWebLogin, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};


export const getBookingDetailsToPrintAgents = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getBookingDetailsToPrintAgents, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const getBusTripGPSDetails = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getBusTripGPSDetails, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};


export const updateCallIntanglesAPI = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpCall(urls.updateCallIntanglesAPI, "post", data, {})
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const updateCallTracknetAPI = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpCall(urls.updateCallTracknetAPI, "post", data, {})
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const getBusTrackingMapLink = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getBusTrackingMapLink, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getYourBusTracking = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpCall(urls.getYourBusTracking, "post", data, {})
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
}

export const getAPIGetPickupsDropoffsBBT = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getAPIGetPickupsDropoffsBBT, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};


export const getBookingsModifyWithNameChangeV2 = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http
            .HttpGet(urls.getBookingsModifyWithNameChangeV2, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
